import React from 'react';
import Link from 'next/link';
import styles from './getInTouch.module.scss';
import config from '../../../config';

const GetInTouch = () => {
    return (
        <div className={styles.getInTouch}>
            <div className="container">
                <div className="row">
                    <div className="col p0">
                        <div className={styles.content}>
                            <p>Join 1000s of the world&apos;s premier tennis academies, clubs, colleges, high schools and tennis federations that use the UTR platform to help increase participation and revenue.</p>
                            <div className={styles.ctaWrapper}>
                                <Link href="/getintouch">
                                    <a className="btn btn-xl btn-white text-gray">
                                        GET IN TOUCH
                                    </a>
                                </Link>
                            </div>
                            <small>
                                For technical issues, please <a href={`https://support.${config.siteBaseUrl}/`} target="_blank" rel="noopener noreferrer" className="text-white fixed-underline">contact support.</a>
                            </small>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default GetInTouch;
